import React from 'react'
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
// import WorkshopWaitlistForm from '../forms/WorkshopWaitlistForm'

export default function GetSubscriberCode({ send, context, workshop }) {
  const date = parseISO(context.workshopData.startTicketSalesDate)
  return (
    <div className="spacing">
      <h2>Event is not live yet</h2>
      <p>Tickets sales start {format(date, 'MMMM do')}.</p>
      {/* <WorkshopWaitlistForm
        ckTag={context.workshopData.ckTag}
        workshopId={workshop.id}
        startDate={workshop.startDate}
      /> */}
    </div>
  )
}
